// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rzY3","field":"styles_field__2ye-z","fieldCol":"styles_fieldCol__2do2h","diffCol":"styles_diffCol__kieV5","diff":"styles_diff__1M9b1"};